
































import Vue from 'vue';

export default Vue.extend({
  props: {
    title: { type: String, default: undefined },
    type: { type: String, default: 'base' },
    hasCloseButton: { type: Boolean, default: true },
  },
  data: () => ({
    maxHeight: undefined as number | undefined,
    maxWidth: undefined as number | undefined,
  }),
  computed: {
    styleList(): Record<string, any> {
      return {
        'max-height': this.maxHeight ? `${this.maxHeight}px` : undefined,
        'max-width': this.maxWidth ? `${this.maxWidth}px` : undefined,
      };
    },
  },
  mounted() {
    document.addEventListener('keydown', this.onKeyDown);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.onKeyDown);
  },
  methods: {
    onKeyDown(evt: KeyboardEvent) {
      evt = evt || window.event;
      if (evt.key === 'Escape' || evt.key === 'Esc') {
        this.closeOnEsc();
      }
    },
    closeOnEsc() {
      this.$emit('closeOnEsc');
      if (this.hasCloseButton) {
        this.close();
      }
    },
    close() {
      this.$emit('close');
      this.$el.remove();
    },
  },
});
